if (window.__galleryDotsRegistered) {
  // already registered
} else {
  window.__galleryDotsRegistered = true;

  function setupGalleryDots(component) {
    const dots = component.querySelectorAll('.slider-counter__dot');
    if (!dots.length) return;

    const slider = component.querySelector('[id^="Slider-"]');
    const items = component.querySelectorAll('[id^="Slide-"]');

    component.addEventListener('slideChanged', function (e) {
      const idx = (e.detail && e.detail.currentPage ? e.detail.currentPage : 1) - 1;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (slider && items[i]) {
          slider.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(setupGalleryDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
}
